import { ImgID } from "../image_loader/img_id.js";

/**
 * List of ImgIDs to pack in the 2D VFX global atlas
 */
export const VFX_2D_ATLAS_CONFIG: ImgID[] = [
  ImgID.IconCoin,
  ImgID.IconPlus,
  ImgID.CircleGlow1,
  ImgID.CircleGlow2,
  ImgID.CircleGlow3,
  ImgID.CircleGlow4,
  ImgID.CircleGlow5,
  ImgID.SparkGlow2,
  ImgID.SparkGlow3,
  ImgID.RaysGlow1,
  ImgID.ConfettiAtlas,
  ImgID.LineGlow1,
  ImgID.UI_ChainOfferLockIcon,
];

export const VFX_2D_ATLAS_SIZE = 1024;
